module.exports = __webpack_public_path__ + "static/media/linkedin_black.0200aada.svg";